"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spanishTranslation = {
    cartListTitle: 'Carrito de compras',
    digitalListTitle: 'Inmediatamente disponible',
    itemLabel: 'Artículo',
    itemsLabel: 'Artículos',
    shippingTitle: 'Envio',
    autoshipAllSubscribe: 'Suscribirse',
    autoshipAllSave: '¡Envía automáticamente productos a tu carrito y ahorra 5%!',
    autoshipFrequencyLabel: 'Frecuencia',
    autoshipSelectFrequency: 'Selección frecuente',
    autoshipQuarterly: 'Trimestral',
    autoshipMonth: 'Mes',
    autoshipMonths: 'Meses',
    autoshipCancelEdit: 'Cancelar edición',
    autoshipEdit: 'editar',
    cartLoginMessageLoginText: 'Acceder',
    cartLoginMessageOrText: 'o',
    cartLoginMessageCreateAccountText: 'crear cuenta ',
    cartLoginMessageEndText: 'para mantener tus artículos guardados. Sin cuenta, los artículos permanecerán en tu carrito de compras durante 30 días.',
    byLineLabel: 'por',
    itemNumberLabel: 'Artículo',
    promotionAppliedLabel1: 'Promoción',
    promotionAppliedLabel2: 'aplicada',
    bundleItemsLabel: 'Artículos incluidos en el paquete',
    autoshipSetupLink: 'Configura pedidos automáticos para este producto',
    eachAbrevLabel: 'cada uno',
    wasText: 'son',
    quantityLabel: 'Cantidad',
    removeItemLabel: 'Eliminar artículo del carrito',
    itemRemovedText: 'eliminado de tu carrito.',
    undoLinkText: 'deshaer',
    closeButtonLabel: 'Cerrar',
    freeShipping: 'Envío gratis aplicable',
    ebook: 'Libro electrónico',
};
exports.default = spanishTranslation;
